<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-retweet"
          :text="$t('ui.refresh')"
          type="button"
          @click="getReportList(true)"
          variant="primary"
          size="sm"
          ).mr-2
        jsonToExcel(v-if="reportList.length > 0" mode="RefereeList" tbl="rltList" :date="dateRange")
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12(style="max-height: 70vh; overflow: hidden;")
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#rltList
            thead.thead-light
              tr
                th.text-center(width="5%")
                  span #
                th(width="10%" @click="sortOrder('account_id')")
                  span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                  .float-right
                    i(:class="changeSortKey('account_id')")
                th(width="10%" @click="sortOrder('full_name')")
                  span(:title="$t('ui.full_name')") {{ $t('ui.full_name') }}
                  .float-right
                    i(:class="changeSortKey('full_name')")
                th(width="10%" @click="sortOrder('contact_phone')")
                  span(:title="$t('ui.contact_phone')") {{ $t('ui.contact_phone') }}
                  .float-right
                    i(:class="changeSortKey('contact_phone')")
                th.text-center(width="10%")
                  span(:title="$t('ui.deposited')") {{ $t('ui.deposited') }}
                th.text-right(width="10%")
                  span(:title="$t('ui.ftd_amount')") {{ $t('ui.ftd_amount') }}
                th.text-center(width="10%")
                  span(:title="$t('ui.vip')") {{ $t('ui.vip') }}
                th.text-right(width="10%" @click="sortOrder('created_date')")
                  span(:title="$t('ui.created_date')") {{ $t('ui.created_date') }}
                  i(:class="changeSortKey('created_date')")
            tbody.clusterize-content
              tr(v-if="reportList.length == 0")
                td(:colspan="8").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in reportList")
                td.text-center
                  span {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(:title="item.account_id") {{ item.account_id }}
                td
                  span(:title="item.full_name") {{ item.full_name }}
                td
                  span(:title="item.contact_phone") {{ item.contact_phone }}
                td.text-center
                  span
                    i(:class="{'fas fa-check text-success': item.deposited == true, 'fas fa-times text-danger': item.deposited == false }")
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.ftd_amount)" :title="$n(item.ftd_amount, 'currency')") {{ $n(item.ftd_amount, 'currency') }}
                td.text-center
                  span(:title="item.vip_id") {{ item.vip_id }} - {{ item.vip_name }}                
                //- td.text-right
                //-   span(:title="$moment(item.verified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.verified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                td.text-right
                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import jsonToExcel from "@/library/jsonToExcel.vue";
import DateRangePicker from "@/library/DateRangePicker.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel
  },
  props: {
    currTab: {
      type: String,
      default: ''
    },
    member: {
      type: Object
    }
  },
  data: () => ({
    loading: false,
    reportList: [],
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    sortKey: "account_id",
    sortType: "asc",
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeMemberReport;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  mounted: function() {
  },
  methods: {
    refresh() {
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.getReportList(true);
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getReportList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    setRefereeListParam: function() {
      var json = {
        referral_code: this.search.trim()
      };
      this.$store.dispatch("user/setRefereeListParam", json);
    },
    getReportList: function(isSearch) {
        let url = config.refereeListUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          referral_code: this.member.referral_code,
          sort_type: this.sortType,
          sort_key: this.sortKey,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.reportList = response.data.dt;
                  this.totalRow = this.reportList.length > 0 ? this.reportList[0].totalrows : 0;
                } else {
                  this.totalRow = 0;
                  this.reportList = [];
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  // if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      // else {
      //   this.totalRow = 0;
      //   this.reportList = [];
      //   this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.searchCriteriaRequired"), "error");
      // }
    },
    changedPageSize: function(pageSize) {
      if(this.currTab != 'refereelist') return
      this.$store.dispatch("layout/setPageSizeMemberReport", pageSize);
      this.currentPage = 1;
      this.getReportList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getReportList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.text-italic {
  font-style: italic !important;
}
</style>